module.exports = __webpack_public_path__ + "static/media/id10t_logo.d25178d2.jpg";